var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 20H15V22H9V20ZM16.906 13.712C17.936 12.506 19 11.259 19 9C19 5.141 15.859 2 12 2C8.141 2 5 5.141 5 9C5 11.285 6.067 12.528 7.101 13.73C7.459 14.148 7.83 14.581 8.185 15.079C8.329 15.285 8.565 16.075 8.776 17H8V19H16V17H15.226C15.439 16.073 15.676 15.281 15.819 15.075C16.171 14.572 16.545 14.135 16.906 13.712ZM14.182 13.925C13.748 14.542 13.386 16 13.176 17H10.825C10.616 15.998 10.253 14.537 9.814 13.92C9.43876 13.4043 9.03966 12.9065 8.618 12.428C7.644 11.294 7 10.544 7 9C7 6.243 9.243 4 12 4C14.757 4 17 6.243 17 9C17 10.521 16.357 11.274 15.385 12.413C15.012 12.851 14.589 13.346 14.182 13.925Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLightbulb);
export default __webpack_public_path__ + "static/media/icon-lightbulb.3c3358c69db4f9a6babc08bea403aee6.svg";
export { ForwardRef as ReactComponent };